/**
 *
 * 状态值
*/

const state = {
  tokenName: JSON.parse(sessionStorage.getItem("tokenName"))||"",
  token: JSON.parse(sessionStorage.getItem("token"))||"",
  lang: JSON.parse(localStorage.getItem("lang"))|| "en",
  userInfo: JSON.parse(sessionStorage.getItem("userInfo"))|| {},
  id: JSON.parse(sessionStorage.getItem("id"))|| "",
  userTags: JSON.parse(sessionStorage.getItem("userTags"))||[],
  unreadCount: JSON.parse(sessionStorage.getItem("unreadCount"))||0,
  unreadSystemCount: JSON.parse(sessionStorage.getItem("unreadSystemCount"))||0,
  unreadCustomerCount: JSON.parse(sessionStorage.getItem("unreadCustomerCount"))||0,

  collapse: JSON.parse(sessionStorage.getItem("collapse"))||false,
  editableTabs: JSON.parse(sessionStorage.getItem("editableTabs"))||[],
  editableTabsValue: JSON.parse(sessionStorage.getItem("editableTabsValue"))||"",
  menuLists: JSON.parse(sessionStorage.getItem("menuLists"))||[],
};

export default state;
